/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as analyticsIndexRouteImport } from './../routes/(analytics)/index'
import { Route as analyticsAppointmentConfirmationRouteImport } from './../routes/(analytics)/appointment-confirmation'
import { Route as analyticsAppointmentSourcesRouteImport } from './../routes/(analytics)/appointment-sources'
import { Route as analyticsEsiaAuthRouteImport } from './../routes/(analytics)/esia-auth'
import { Route as analyticsKeyMetricsRouteImport } from './../routes/(analytics)/key-metrics'
import { Route as analyticsLeadsRouteImport } from './../routes/(analytics)/leads'
import { Route as analyticsReviewsRouteImport } from './../routes/(analytics)/reviews'
import { Route as analyticsWidgetStatsRouteImport } from './../routes/(analytics)/widget-stats'
import { Route as marketingMarketingRouteRouteImport } from './../routes/(marketing)/marketing/route'
import { Route as settingsSettingsOnlineBookingRouteImport } from './../routes/(settings)/settings/online-booking'
import { Route as marketingMarketingExportsIndexRouteImport } from './../routes/(marketing)/marketing/exports/index'
import { Route as marketingMarketingExportsTaskIdRouteImport } from './../routes/(marketing)/marketing/exports/$taskId'
import { Route as marketingMarketingExportsNewRouteImport } from './../routes/(marketing)/marketing/exports/new'
import { Route as marketingMarketingMailingsIndexRouteImport } from './../routes/(marketing)/marketing/mailings/index'
import { Route as marketingMarketingMailingsTaskIdRouteImport } from './../routes/(marketing)/marketing/mailings/$taskId'
import { Route as marketingMarketingMailingsNewRouteImport } from './../routes/(marketing)/marketing/mailings/new'
import { Route as marketingMarketingReportingIndexRouteImport } from './../routes/(marketing)/marketing/reporting/index'
import { Route as marketingMarketingReportingRunIdRouteImport } from './../routes/(marketing)/marketing/reporting/$runId'

const analyticsIndexRoute = analyticsIndexRouteImport.update({
  id: '/(analytics)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const analyticsAppointmentConfirmationRoute =
  analyticsAppointmentConfirmationRouteImport.update({
    id: '/(analytics)/appointment-confirmation',
    path: '/appointment-confirmation',
    getParentRoute: () => rootRouteImport,
  } as any)
const analyticsAppointmentSourcesRoute =
  analyticsAppointmentSourcesRouteImport.update({
    id: '/(analytics)/appointment-sources',
    path: '/appointment-sources',
    getParentRoute: () => rootRouteImport,
  } as any)
const analyticsEsiaAuthRoute = analyticsEsiaAuthRouteImport.update({
  id: '/(analytics)/esia-auth',
  path: '/esia-auth',
  getParentRoute: () => rootRouteImport,
} as any)
const analyticsKeyMetricsRoute = analyticsKeyMetricsRouteImport.update({
  id: '/(analytics)/key-metrics',
  path: '/key-metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const analyticsLeadsRoute = analyticsLeadsRouteImport.update({
  id: '/(analytics)/leads',
  path: '/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const analyticsReviewsRoute = analyticsReviewsRouteImport.update({
  id: '/(analytics)/reviews',
  path: '/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const analyticsWidgetStatsRoute = analyticsWidgetStatsRouteImport.update({
  id: '/(analytics)/widget-stats',
  path: '/widget-stats',
  getParentRoute: () => rootRouteImport,
} as any)
const marketingMarketingRouteRoute = marketingMarketingRouteRouteImport.update({
  id: '/(marketing)/marketing',
  path: '/marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const settingsSettingsOnlineBookingRoute =
  settingsSettingsOnlineBookingRouteImport.update({
    id: '/(settings)/settings/online-booking',
    path: '/settings/online-booking',
    getParentRoute: () => rootRouteImport,
  } as any)
const marketingMarketingExportsIndexRoute =
  marketingMarketingExportsIndexRouteImport.update({
    id: '/exports/',
    path: '/exports/',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)
const marketingMarketingExportsTaskIdRoute =
  marketingMarketingExportsTaskIdRouteImport.update({
    id: '/exports/$taskId',
    path: '/exports/$taskId',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)
const marketingMarketingExportsNewRoute =
  marketingMarketingExportsNewRouteImport.update({
    id: '/exports/new',
    path: '/exports/new',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)
const marketingMarketingMailingsIndexRoute =
  marketingMarketingMailingsIndexRouteImport.update({
    id: '/mailings/',
    path: '/mailings/',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)
const marketingMarketingMailingsTaskIdRoute =
  marketingMarketingMailingsTaskIdRouteImport.update({
    id: '/mailings/$taskId',
    path: '/mailings/$taskId',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)
const marketingMarketingMailingsNewRoute =
  marketingMarketingMailingsNewRouteImport.update({
    id: '/mailings/new',
    path: '/mailings/new',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)
const marketingMarketingReportingIndexRoute =
  marketingMarketingReportingIndexRouteImport.update({
    id: '/reporting/',
    path: '/reporting/',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)
const marketingMarketingReportingRunIdRoute =
  marketingMarketingReportingRunIdRouteImport.update({
    id: '/reporting/$runId',
    path: '/reporting/$runId',
    getParentRoute: () => marketingMarketingRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/marketing': typeof marketingMarketingRouteRouteWithChildren
  '/appointment-confirmation': typeof analyticsAppointmentConfirmationRoute
  '/appointment-sources': typeof analyticsAppointmentSourcesRoute
  '/esia-auth': typeof analyticsEsiaAuthRoute
  '/key-metrics': typeof analyticsKeyMetricsRoute
  '/leads': typeof analyticsLeadsRoute
  '/reviews': typeof analyticsReviewsRoute
  '/widget-stats': typeof analyticsWidgetStatsRoute
  '/': typeof analyticsIndexRoute
  '/settings/online-booking': typeof settingsSettingsOnlineBookingRoute
  '/marketing/exports/$taskId': typeof marketingMarketingExportsTaskIdRoute
  '/marketing/exports/new': typeof marketingMarketingExportsNewRoute
  '/marketing/mailings/$taskId': typeof marketingMarketingMailingsTaskIdRoute
  '/marketing/mailings/new': typeof marketingMarketingMailingsNewRoute
  '/marketing/reporting/$runId': typeof marketingMarketingReportingRunIdRoute
  '/marketing/exports/': typeof marketingMarketingExportsIndexRoute
  '/marketing/mailings/': typeof marketingMarketingMailingsIndexRoute
  '/marketing/reporting/': typeof marketingMarketingReportingIndexRoute
}
export interface FileRoutesByTo {
  '/marketing': typeof marketingMarketingRouteRouteWithChildren
  '/appointment-confirmation': typeof analyticsAppointmentConfirmationRoute
  '/appointment-sources': typeof analyticsAppointmentSourcesRoute
  '/esia-auth': typeof analyticsEsiaAuthRoute
  '/key-metrics': typeof analyticsKeyMetricsRoute
  '/leads': typeof analyticsLeadsRoute
  '/reviews': typeof analyticsReviewsRoute
  '/widget-stats': typeof analyticsWidgetStatsRoute
  '/': typeof analyticsIndexRoute
  '/settings/online-booking': typeof settingsSettingsOnlineBookingRoute
  '/marketing/exports/$taskId': typeof marketingMarketingExportsTaskIdRoute
  '/marketing/exports/new': typeof marketingMarketingExportsNewRoute
  '/marketing/mailings/$taskId': typeof marketingMarketingMailingsTaskIdRoute
  '/marketing/mailings/new': typeof marketingMarketingMailingsNewRoute
  '/marketing/reporting/$runId': typeof marketingMarketingReportingRunIdRoute
  '/marketing/exports': typeof marketingMarketingExportsIndexRoute
  '/marketing/mailings': typeof marketingMarketingMailingsIndexRoute
  '/marketing/reporting': typeof marketingMarketingReportingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(marketing)/marketing': typeof marketingMarketingRouteRouteWithChildren
  '/(analytics)/appointment-confirmation': typeof analyticsAppointmentConfirmationRoute
  '/(analytics)/appointment-sources': typeof analyticsAppointmentSourcesRoute
  '/(analytics)/esia-auth': typeof analyticsEsiaAuthRoute
  '/(analytics)/key-metrics': typeof analyticsKeyMetricsRoute
  '/(analytics)/leads': typeof analyticsLeadsRoute
  '/(analytics)/reviews': typeof analyticsReviewsRoute
  '/(analytics)/widget-stats': typeof analyticsWidgetStatsRoute
  '/(analytics)/': typeof analyticsIndexRoute
  '/(settings)/settings/online-booking': typeof settingsSettingsOnlineBookingRoute
  '/(marketing)/marketing/exports/$taskId': typeof marketingMarketingExportsTaskIdRoute
  '/(marketing)/marketing/exports/new': typeof marketingMarketingExportsNewRoute
  '/(marketing)/marketing/mailings/$taskId': typeof marketingMarketingMailingsTaskIdRoute
  '/(marketing)/marketing/mailings/new': typeof marketingMarketingMailingsNewRoute
  '/(marketing)/marketing/reporting/$runId': typeof marketingMarketingReportingRunIdRoute
  '/(marketing)/marketing/exports/': typeof marketingMarketingExportsIndexRoute
  '/(marketing)/marketing/mailings/': typeof marketingMarketingMailingsIndexRoute
  '/(marketing)/marketing/reporting/': typeof marketingMarketingReportingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/marketing'
    | '/appointment-confirmation'
    | '/appointment-sources'
    | '/esia-auth'
    | '/key-metrics'
    | '/leads'
    | '/reviews'
    | '/widget-stats'
    | '/'
    | '/settings/online-booking'
    | '/marketing/exports/$taskId'
    | '/marketing/exports/new'
    | '/marketing/mailings/$taskId'
    | '/marketing/mailings/new'
    | '/marketing/reporting/$runId'
    | '/marketing/exports/'
    | '/marketing/mailings/'
    | '/marketing/reporting/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/marketing'
    | '/appointment-confirmation'
    | '/appointment-sources'
    | '/esia-auth'
    | '/key-metrics'
    | '/leads'
    | '/reviews'
    | '/widget-stats'
    | '/'
    | '/settings/online-booking'
    | '/marketing/exports/$taskId'
    | '/marketing/exports/new'
    | '/marketing/mailings/$taskId'
    | '/marketing/mailings/new'
    | '/marketing/reporting/$runId'
    | '/marketing/exports'
    | '/marketing/mailings'
    | '/marketing/reporting'
  id:
    | '__root__'
    | '/(marketing)/marketing'
    | '/(analytics)/appointment-confirmation'
    | '/(analytics)/appointment-sources'
    | '/(analytics)/esia-auth'
    | '/(analytics)/key-metrics'
    | '/(analytics)/leads'
    | '/(analytics)/reviews'
    | '/(analytics)/widget-stats'
    | '/(analytics)/'
    | '/(settings)/settings/online-booking'
    | '/(marketing)/marketing/exports/$taskId'
    | '/(marketing)/marketing/exports/new'
    | '/(marketing)/marketing/mailings/$taskId'
    | '/(marketing)/marketing/mailings/new'
    | '/(marketing)/marketing/reporting/$runId'
    | '/(marketing)/marketing/exports/'
    | '/(marketing)/marketing/mailings/'
    | '/(marketing)/marketing/reporting/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  marketingMarketingRouteRoute: typeof marketingMarketingRouteRouteWithChildren
  analyticsAppointmentConfirmationRoute: typeof analyticsAppointmentConfirmationRoute
  analyticsAppointmentSourcesRoute: typeof analyticsAppointmentSourcesRoute
  analyticsEsiaAuthRoute: typeof analyticsEsiaAuthRoute
  analyticsKeyMetricsRoute: typeof analyticsKeyMetricsRoute
  analyticsLeadsRoute: typeof analyticsLeadsRoute
  analyticsReviewsRoute: typeof analyticsReviewsRoute
  analyticsWidgetStatsRoute: typeof analyticsWidgetStatsRoute
  analyticsIndexRoute: typeof analyticsIndexRoute
  settingsSettingsOnlineBookingRoute: typeof settingsSettingsOnlineBookingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(analytics)/': {
      id: '/(analytics)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof analyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(analytics)/appointment-confirmation': {
      id: '/(analytics)/appointment-confirmation'
      path: '/appointment-confirmation'
      fullPath: '/appointment-confirmation'
      preLoaderRoute: typeof analyticsAppointmentConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(analytics)/appointment-sources': {
      id: '/(analytics)/appointment-sources'
      path: '/appointment-sources'
      fullPath: '/appointment-sources'
      preLoaderRoute: typeof analyticsAppointmentSourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(analytics)/esia-auth': {
      id: '/(analytics)/esia-auth'
      path: '/esia-auth'
      fullPath: '/esia-auth'
      preLoaderRoute: typeof analyticsEsiaAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(analytics)/key-metrics': {
      id: '/(analytics)/key-metrics'
      path: '/key-metrics'
      fullPath: '/key-metrics'
      preLoaderRoute: typeof analyticsKeyMetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(analytics)/leads': {
      id: '/(analytics)/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof analyticsLeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(analytics)/reviews': {
      id: '/(analytics)/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof analyticsReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(analytics)/widget-stats': {
      id: '/(analytics)/widget-stats'
      path: '/widget-stats'
      fullPath: '/widget-stats'
      preLoaderRoute: typeof analyticsWidgetStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(marketing)/marketing': {
      id: '/(marketing)/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof marketingMarketingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(settings)/settings/online-booking': {
      id: '/(settings)/settings/online-booking'
      path: '/settings/online-booking'
      fullPath: '/settings/online-booking'
      preLoaderRoute: typeof settingsSettingsOnlineBookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(marketing)/marketing/exports/': {
      id: '/(marketing)/marketing/exports/'
      path: '/exports'
      fullPath: '/marketing/exports/'
      preLoaderRoute: typeof marketingMarketingExportsIndexRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
    '/(marketing)/marketing/exports/$taskId': {
      id: '/(marketing)/marketing/exports/$taskId'
      path: '/exports/$taskId'
      fullPath: '/marketing/exports/$taskId'
      preLoaderRoute: typeof marketingMarketingExportsTaskIdRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
    '/(marketing)/marketing/exports/new': {
      id: '/(marketing)/marketing/exports/new'
      path: '/exports/new'
      fullPath: '/marketing/exports/new'
      preLoaderRoute: typeof marketingMarketingExportsNewRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
    '/(marketing)/marketing/mailings/': {
      id: '/(marketing)/marketing/mailings/'
      path: '/mailings'
      fullPath: '/marketing/mailings/'
      preLoaderRoute: typeof marketingMarketingMailingsIndexRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
    '/(marketing)/marketing/mailings/$taskId': {
      id: '/(marketing)/marketing/mailings/$taskId'
      path: '/mailings/$taskId'
      fullPath: '/marketing/mailings/$taskId'
      preLoaderRoute: typeof marketingMarketingMailingsTaskIdRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
    '/(marketing)/marketing/mailings/new': {
      id: '/(marketing)/marketing/mailings/new'
      path: '/mailings/new'
      fullPath: '/marketing/mailings/new'
      preLoaderRoute: typeof marketingMarketingMailingsNewRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
    '/(marketing)/marketing/reporting/': {
      id: '/(marketing)/marketing/reporting/'
      path: '/reporting'
      fullPath: '/marketing/reporting/'
      preLoaderRoute: typeof marketingMarketingReportingIndexRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
    '/(marketing)/marketing/reporting/$runId': {
      id: '/(marketing)/marketing/reporting/$runId'
      path: '/reporting/$runId'
      fullPath: '/marketing/reporting/$runId'
      preLoaderRoute: typeof marketingMarketingReportingRunIdRouteImport
      parentRoute: typeof marketingMarketingRouteRoute
    }
  }
}

interface marketingMarketingRouteRouteChildren {
  marketingMarketingExportsTaskIdRoute: typeof marketingMarketingExportsTaskIdRoute
  marketingMarketingExportsNewRoute: typeof marketingMarketingExportsNewRoute
  marketingMarketingMailingsTaskIdRoute: typeof marketingMarketingMailingsTaskIdRoute
  marketingMarketingMailingsNewRoute: typeof marketingMarketingMailingsNewRoute
  marketingMarketingReportingRunIdRoute: typeof marketingMarketingReportingRunIdRoute
  marketingMarketingExportsIndexRoute: typeof marketingMarketingExportsIndexRoute
  marketingMarketingMailingsIndexRoute: typeof marketingMarketingMailingsIndexRoute
  marketingMarketingReportingIndexRoute: typeof marketingMarketingReportingIndexRoute
}

const marketingMarketingRouteRouteChildren: marketingMarketingRouteRouteChildren =
  {
    marketingMarketingExportsTaskIdRoute: marketingMarketingExportsTaskIdRoute,
    marketingMarketingExportsNewRoute: marketingMarketingExportsNewRoute,
    marketingMarketingMailingsTaskIdRoute:
      marketingMarketingMailingsTaskIdRoute,
    marketingMarketingMailingsNewRoute: marketingMarketingMailingsNewRoute,
    marketingMarketingReportingRunIdRoute:
      marketingMarketingReportingRunIdRoute,
    marketingMarketingExportsIndexRoute: marketingMarketingExportsIndexRoute,
    marketingMarketingMailingsIndexRoute: marketingMarketingMailingsIndexRoute,
    marketingMarketingReportingIndexRoute:
      marketingMarketingReportingIndexRoute,
  }

const marketingMarketingRouteRouteWithChildren =
  marketingMarketingRouteRoute._addFileChildren(
    marketingMarketingRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  marketingMarketingRouteRoute: marketingMarketingRouteRouteWithChildren,
  analyticsAppointmentConfirmationRoute: analyticsAppointmentConfirmationRoute,
  analyticsAppointmentSourcesRoute: analyticsAppointmentSourcesRoute,
  analyticsEsiaAuthRoute: analyticsEsiaAuthRoute,
  analyticsKeyMetricsRoute: analyticsKeyMetricsRoute,
  analyticsLeadsRoute: analyticsLeadsRoute,
  analyticsReviewsRoute: analyticsReviewsRoute,
  analyticsWidgetStatsRoute: analyticsWidgetStatsRoute,
  analyticsIndexRoute: analyticsIndexRoute,
  settingsSettingsOnlineBookingRoute: settingsSettingsOnlineBookingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
